import type { ChatPerson } from "../../api/chat";

/** The role a colleague is shown with: the most senior of theirs. */
const SENIORITY = ["SUPERADMIN", "ADMIN", "SALES_DIRECTOR", "KVALITET_LEAD", "SALES", "OTKUP", "KVALITET", "MARKETING", "PORTIR"];

export function roleLabel(person: ChatPerson, t: (key: string, fallback: string) => string): string {
  const role = SENIORITY.find((r) => person.roles.includes(r));
  if (!role) return "";
  // The gate operator has no label among the user-administration roles, which predate the role.
  if (role === "PORTIR") return t("chat.rolePortir", "Gate");
  return t(`admin.users.role.${role}`, role);
}
